export const isUnsafeString = (value) => {
  if (typeof value !== 'string') return false;
  const patterns = [
    /<\s*script\b/i,
    /javascript\s*:/i,
    /on\w+\s*=/i,
    /<\s*iframe\b/i,
    /<\s*img\b/i,
    /<\s*svg\b/i,
    /<\s*style\b/i,
    /<\s*link\b/i,
  ];
  return patterns.some((rx) => rx.test(value));
};

const isSkippableObject = (value) => {
  return (
    value instanceof Date ||
    value instanceof RegExp ||
    (typeof FormData !== 'undefined' && value instanceof FormData) ||
    (typeof File !== 'undefined' && value instanceof File) ||
    (typeof Blob !== 'undefined' && value instanceof Blob)
  );
};

export const scanForUnsafeInput = (input, currentPath = '') => {
  if (input == null) return; // null or undefined

  // Skip sanitization for password fields (they are RSA encrypted)
  if (currentPath.toLowerCase().includes('password')) {
    return;
  }

  if (typeof input === 'string') {
    if (isUnsafeString(input)) {
      const error = new Error(
        'Unsafe input detected. Please remove HTML or script-like content and try again.'
      );
      error.code = 'INPUT_VALIDATION';
      error.path = currentPath;
      error.response = {
        data: {
          message:
            'Unsafe input detected. Remove HTML/script content and try again.',
        },
      };
      throw error;
    }
    return;
  }

  if (typeof input !== 'object') return;
  if (isSkippableObject(input)) return;

  if (Array.isArray(input)) {
    for (let index = 0; index < input.length; index++) {
      scanForUnsafeInput(input[index], `${currentPath}[${index}]`);
    }
    return;
  }

  for (const key of Object.keys(input)) {
    const nextPath = currentPath ? `${currentPath}.${key}` : key;
    scanForUnsafeInput(input[key], nextPath);
  }
};
